import { DefaultService } from '@/services/DefaultService';

export default class ProContratoProdutoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAllByContrato(column, order, page, limit, situacao, idcontrato, tipo, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/contrato/contratoproduto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcontrato=${idcontrato}&tipo=${tipo}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(asscontratoproduto) {
        return this._http
            .post(
                `${this._env}/promotor/contrato/contratoproduto/updatesituacao`,
                asscontratoproduto,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllByContratoNaoAssociados(column, order, page, limit, idcontrato, tipo, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/contrato/contratoproduto/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcontrato=${idcontrato}&tipo=${tipo}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    saveByContrato(listaproduto) {
        return this._http
            .post(`${this._env}/promotor/contratoproduto/bulk`, listaproduto, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
